import React, { useMemo, useState } from "react";

const RankingCard = ({ title = "Leadership Ranking", rankings = [] }) => {
  const [showInfo, setShowInfo] = useState(false);
  const topThree = rankings.slice(0, 3);
  const currentUser = useMemo(
    () => rankings.find((r) => r.isCurrentUser),
    [rankings],
  );

  return (
    <div className="ranking-card">
      <div className="leadership-header">
        <div className="leadership-logo-container">
          <img
            src="/images/crown.png"
            alt="Leadership"
            className="leadership-logo"
          />
          <div className="leadership-chart-title">{title}</div>
          <button
            type="button"
            className="ranking-info-btn"
            aria-label="How are ranking points calculated?"
            onClick={() => setShowInfo((v) => !v)}
          >
            ⓘ
          </button>
          {showInfo && (
            <div className="ranking-info-popover">
              Points = Average Rating × Number of Reviews. Earn more reviews
              and keep your rating high to climb the leaderboard.
            </div>
          )}
        </div>
      </div>

      <div className="ranking-container">
        {topThree.map((item) => (
          <div
            key={item.position}
            className={`ranking-item ${item.isCurrentUser ? "current-user" : ""}`}
          >
            <span className="rank-position">#{item.position}</span>
            <div className="rank-user-info">
              <img
                src={item.avatar || "/images/avatar.png"}
                 alt={item.name}
                className="rank-avatar"
              />
              <span className="rank-name">{item.name}</span>
            </div>
            <span className="rank-points">
              {item.points.toLocaleString()} Points
            </span>
          </div>
        ))}

        {currentUser && currentUser.position > 3 && (
          <div className="ranking-highlight">
            <div className="ranking-item current-user">
              <span className="rank-position">#{currentUser.position}</span>
              <div className="rank-user-info">
                <img
                  src={currentUser.avatar}
                  alt="You"
                  className="rank-avatar"
                />
                <span className="rank-name">{currentUser.name}</span>
              </div>
              <span className="rank-points">{currentUser.points} pts</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RankingCard;
